export default __webpack_public_path__ + "abbdb866577b658ab7bd274d8b30f460.png";